import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=3ce4cb71&"
import script from "./Nav.vue?vue&type=script&lang=js&"
export * from "./Nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Nav: require('/builds/2oYM8JSf/1/mcp/sk-soutez-2022/frontend/components/Nav.vue').default})
